module.exports = __webpack_public_path__ + "static/media/popi-illustration.0042f1a9.svg";